export default {
  state: {
    mostrarModalConfirmar: false,
    callbackModalConfirmar: () => {},
    larguraModalConfirmar: 500,
    tituloModalConfirmar: "",
    mensagemModalConfirmar: "",
    textoBotaoModalConfirmar: "",
    tipoBotaoModalConfirmar: "primario",
    larguraBotaoModalConfirmar: 156,
    callbackFecharModalConfirmar: null,
    callbackAbrirModalConfirmar: null,
    objetoConfirmarVazio: {
      mostrarModalConfirmar: false,
      callbackModalConfirmar: () => {},
      larguraModalConfirmar: 500,
      tituloModalConfirmar: "",
      mensagemModalConfirmar: "",
      textoBotaoModalConfirmar: "",
      tipoBotaoModalConfirmar: "primario",
      larguraBotaoModalConfirmar: 156,
      callbackFecharModalConfirmar: null,
      callbackAbrirModalConfirmar: null
    }
  },
  actions: {
    setMostrarModalConfirmarResumido({ commit, state }, objetoModal) {
      const {
        mostrarModalConfirmar,
        callbackModalConfirmar,
        larguraModalConfirmar,
        tituloModalConfirmar,
        mensagemModalConfirmar,
        textoBotaoModalConfirmar,
        tipoBotaoModalConfirmar,
        larguraBotaoModalConfirmar
      } = objetoModal;

      const {
        larguraModalConfirmar: larguraModalConfirmarVazio,
        tipoBotaoModalConfirmar: tipoBotaoModalConfirmarVazio,
        larguraBotaoModalConfirmar: larguraBotaoModalConfirmarVazio
      } = state.objetoConfirmarVazio;

      commit("setMostrarModalConfirmar", mostrarModalConfirmar);
      commit("setCallbackModalConfirmar", callbackModalConfirmar);
      commit("setTituloModalConfirmar", tituloModalConfirmar);
      commit("setMensagemModalConfirmar", mensagemModalConfirmar);
      commit("setTextoBotaoModalConfirmar", textoBotaoModalConfirmar);
      commit(
        "setLarguraModalConfirmar",
        larguraModalConfirmar || larguraModalConfirmarVazio
      );
      commit(
        "setTipoBotaoModalConfirmar",
        tipoBotaoModalConfirmar || tipoBotaoModalConfirmarVazio
      );
      commit(
        "setLarguraBotaoModalConfirmar",
        larguraBotaoModalConfirmar || larguraBotaoModalConfirmarVazio
      );
    }
  },
  mutations: {
    setMostrarModalConfirmar(state, _mostrar) {
      state.mostrarModalConfirmar = _mostrar;
      if (_mostrar && state.callbackAbrirModalConfirmar !== null) {
        state.callbackAbrirModalConfirmar();
      } else if (!_mostrar && state.callbackFecharModalConfirmar !== null) {
        state.callbackFecharModalConfirmar();
      }
    },
    setCallbackModalConfirmar(state, _callback) {
      state.callbackModalConfirmar = _callback;
    },
    setLarguraModalConfirmar(state, _largura) {
      state.larguraModalConfirmar = _largura;
    },
    setTituloModalConfirmar(state, _titulo) {
      state.tituloModalConfirmar = _titulo;
    },
    setMensagemModalConfirmar(state, _mensagem) {
      state.mensagemModalConfirmar = _mensagem;
    },
    setTextoBotaoModalConfirmar(state, _texto) {
      state.textoBotaoModalConfirmar = _texto;
    },
    setTipoBotaoModalConfirmar(state, _tipo) {
      state.tipoBotaoModalConfirmar = _tipo;
    },
    setLarguraBotaoModalConfirmar(state, _largura) {
      state.larguraBotaoModalConfirmar = _largura;
    },
    setCallbackFecharModalConfirmar(state, _callback) {
      state.callbackFecharModalConfirmar = _callback;
    },
    setCallbackAbrirModalConfirmar(state, _callback) {
      state.callbackAbrirModalConfirmar = _callback;
    },
    setLimparCallbacksConfirmar(state) {
      state.callbackFecharModalConfirmar = null;
      state.callbackAbrirModalConfirmar = null;
    }
  },
  getters: {
    getMostrarModalConfirmar: state => state.mostrarModalConfirmar,
    getCallbackModalConfirmar: state => state.callbackModalConfirmar,
    getLarguraModalConfirmar: state => state.larguraModalConfirmar,
    getTituloModalConfirmar: state => state.tituloModalConfirmar,
    getMensagemModalConfirmar: state => state.mensagemModalConfirmar,
    getTextoBotaoModalConfirmar: state => state.textoBotaoModalConfirmar,
    getTipoBotaoModalConfirmar: state => state.tipoBotaoModalConfirmar,
    getLarguraBotaoModalConfirmar: state => state.larguraBotaoModalConfirmar
  }
};
